import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import configureStore from './stores';
import i18n from './i18n';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-owl-carousel2/lib/styles.css';
import './css/libs/animate.css';
import './css/style.css';
import './css/custom.css';
import registerServiceWorker from './registerServiceWorker';

const store = configureStore();

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<I18nextProvider i18n={ i18n }><App /></I18nextProvider>
		</BrowserRouter>
	</Provider>,
	document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx